var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("403")]),_c('p',[_vm._v("您没有权限访问此页面")])])
}]

export { render, staticRenderFns }